import { languages } from './languages';

export { languages };

export const translations = {
  en: {
    // Dashboard
    dashboard: "Dashboard",
    overview: "Overview",
    accountSettings: "Account Settings",
    payments: "Payments",
    wallets: "Wallets",
    transactions: "Transactions",
    supportTickets: "Support Tickets",
    safetyGuide: "Safety Guide",
    exchange: "Exchange",
    swapCrypto: "Swap Crypto",
    swap: "Swap",
    stake: "Stake",
    
    // Navigation
    general: "General",
    marketplace: "MARKETPLACE",
    needHelp: "Need Help?",
    contactSupport: "Contact Support",
    contactSupportTeam: "Contact our customer support team",
    
    // TopBar
    notifications: "Notifications",
    notification: "Notification",
    youHave: "You have",
    unreadNotifications: "unread notifications",
    clearAll: "Clear All",
    noNotifications: "No unread notifications",
    profile: "Profile",
    logout: "Logout",
    
    // Support Tickets
    createTicket: "Create Ticket",
    createSupportTicket: "Create Support Ticket",
    noActiveTickets: "No Active Support Tickets",
    loadingTickets: "Loading tickets...",
    goBack: "Go Back",
    subject: "Subject",
    urgency: "Urgency",
    message: "Message",
    low: "Low",
    medium: "Medium",
    high: "High",
    createTicketButton: "Create Ticket",
    creating: "Creating...",
    ticketNote: "Please note that support tickets are usually answered within 24 hours, depending on the urgency of the ticket.",
    supportTicketNote: "Please note that support tickets are usually answered within 24 hours, depending on the urgency of the ticket.",
    
    // Common
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    close: "Close",
    open: "Open",
    status: "Status",
    on: "On",
    off: "Off",
    disable: "Disable",
    date: "Date",
    amount: "Amount",
    currency: "Currency",
    description: "Description",
    actions: "Actions",
    
    // Overview
    totalBalance: "Total Balance",
    portfolioValue: "Portfolio Value",
    totalProfit: "Total Profit",
    totalLoss: "Total Loss",
    recentTransactions: "Recent Transactions",
    marketTrends: "Market Trends",
    quickActions: "Quick Actions",
    buyCrypto: "Buy Crypto",
    sendMoney: "Send Money",
    receiveMoney: "Receive Money",
    
    // Wallets
    myWallets: "My Wallets",
    addWallet: "Add Wallet",
    walletAddress: "Wallet Address",
    walletBalance: "Wallet Balance",
    walletType: "Wallet Type",
    hotWallet: "Hot Wallet",
    coldWallet: "Cold Wallet",
    
    // Transactions
    transactionHistory: "Transaction History",
    transactionType: "Transaction Type",
    transactionStatus: "Transaction Status",
    from: "From",
    to: "To",
    loadingTransactions: "Loading transactions...",
    noTransactions: "No transactions found",
    fee: "Fee",
    hash: "Hash",
    pending: "Pending",
    processing: "Processing",
    completed: "Completed",
    failed: "Failed",
    cancelled: "Cancelled",
    
    // Payments
    paymentMethods: "Payment Methods",
    paymentMethod: "Payment Method",
    addPaymentMethod: "Add Payment Method",
    creditCard: "Credit Card",
    bankAccount: "Bank Account",
    cryptoWallet: "Crypto Wallet",
    cardNumber: "Card Number",
    expiryDate: "Expiry Date",
    cvv: "CVV",
    accountNumber: "Account Number",
    routingNumber: "Routing Number",
    withdrawal: "Withdrawal",
    deposit: "Deposit",
    totalAmount: "Total Amount",
    
    // Exchange
    cryptoExchange: "Crypto Exchange",
    buy: "Buy",
    sell: "Sell",
    swap: "Swap",
    fromCurrency: "From Currency",
    toCurrency: "To Currency",
    exchangeRate: "Exchange Rate",
    estimatedAmount: "Estimated Amount",
    confirmExchange: "Confirm Exchange",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Staked Amount",
    rewards: "Rewards",
    apy: "APY",
    lockPeriod: "Lock Period",
    unstake: "Unstake",
    stakeMore: "Stake More",
    
    // Stake Elements
    duration: "Duration",
    rate: "Rate",
    minValue: "Min Value",
    maxValue: "Max Value",
    days7: "7 Days",
    days14: "14 Days",
    days30: "30 Days",
    
    // Cryptocurrency Names for Staking
    bitcoinStake: "Bitcoin Stake",
    ethereumStake: "Ethereum Stake",
    tetherUsdtStake: "Tether USDT Stake",
    bnbStake: "BNB Stake",
    solanaStake: "Solana Stake",
    xrpStake: "XRP Stake",
    cardanoStake: "Cardano Stake",
    dogecoinStake: "Dogecoin Stake",
    litecoinStake: "Litecoin Stake",
    moneroStake: "Monero Stake",
    polygonStake: "Polygon Stake",
    tronStake: "TRON Stake",
    usdStake: "USD Stake",
    eurStake: "EUR Stake",
    
    // Account Settings
    personalInformation: "Personal Information",
    security: "Security",
    notifications: "Notifications",
    preferences: "Preferences",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    phone: "Phone",
    country: "Country",
    timezone: "Timezone",
    language: "Language",
    changePassword: "Change Password",
    twoFactorAuth: "Two-Factor Authentication",
    enable2FA: "Enable 2FA",
    disable2FA: "Disable 2FA",
    
    // Account Settings - Basic Details
    basicDetails: "Basic Details",
    emailAddress: "Email Address",
    dateOfBirth: "Date of Birth",
    city: "City",
    postalCode: "Postal Code",
    fullAddress: "Full Address",
    dateFormatHint: "Format: YYYY-MM-DD",
    saveChanges: "Save Changes",
    loadingUserData: "Loading user data...",
    
    // Account Settings - Payment Methods
    paymentMethodsDesc: "Add and manage your payment methods for deposits and withdrawals",
    addNew: "Add New",
    nothingHere: "Nothing here",
    addPaymentMethodToStart: "Add a payment method to start",
    
    // Account Settings - Verification
    verification: "Verification",
    verifyAccountKyc: "Verify your account with KYC",
    personalInformation: "Personal Information",
    personalInformationDesc: "Please provide your personal information to complete the verification process",
    documentUpload: "Document Upload",
    documentUploadDesc: "Upload your identification documents for verification",
    uploadDocuments: "Upload Documents",
    verificationComplete: "Verification Complete",
    completeKycVerification: "Complete KYC Verification",
    completeKycVerificationDesc: "Your verification is complete. You can now use all features.",
    startKycVerification: "Start KYC Verification",
    nextStep: "Next Step",
    driverLicense: "Proof of ID (Front)",
    selfie: "Selfie",
    driverLicenseDesc: "Upload a clear photo of your Identification Document",
    selfieDesc: "Take a clear selfie with your face visible",
    alreadyUploaded: "Already uploaded",
    clickToReplace: "Click to replace",
    uploadSelectedDocuments: "Upload Selected Documents",
    uploadBothDocuments: "Upload Documents",
    documentsAlreadyUploaded: "Documents Already Uploaded",
    viewFullSize: "View Full Size",
    uploading: "Uploading...",
    isVerified: "is verified",
    notVerified: "not verified",
    kycIsVerified: "KYC is verified",
    kycNotVerified: "KYC Not Verified",
    kycVerifiedDescription: "Your account is verified, you can use all features",
    
    // Account Settings - Notifications
    emailNotifications: "Email Notifications",
    transactionReceived: "Transaction Received",
    transactionReceivedDesc: "Get notified when you receive funds",
    transactionSent: "Transaction Sent",
    transactionSentDesc: "Get notified when you send funds",
    accountChanges: "Account Changes",
    accountChangesDesc: "Get notified about important account changes",
    stakeRewards: "Stake Rewards",
    stakeRewardsDesc: "Get notified about your staking rewards",
    
    // Account Settings - Security
    loginHistory: "Login History",
    recentLoginActivity: "Recent login activity",
    loginType: "Login Type",
    ipAddress: "IP Address",
    client: "Client",
    showMore: "Show more",
    noLoginHistory: "No login history yet",
    newIpLogin: "New IP",
    multiFactorAuthentication: "Multi-Factor Authentication",
    authenticatorApp: "Authenticator App",
    authenticatorAppDesc: "Use an authenticator app for additional security",
    emailAuthentication: "Email Authentication",
    emailAuthenticationDesc: "Receive authentication codes via email",
    setUp: "Set Up",
    resendEmail: "Resend email",
    emailAuthEmailSent: "Confirmation link sent to your email.",
    emailAuthDisabled: "Email Authentication disabled.",
    emailAuthActionFailed: "Email Authentication request failed.",
    emailAuthStatusFailed: "Failed to load Email Authentication status.",
    enabled: "Enabled",
    continueSetup: "Continue setup",
    manualSetupKey: "Manual setup key",
    authenticationCode: "Authentication code",
    enableAuthenticator: "Enable Authenticator",
    authenticatorSetupReady: "Scan the QR code and enter the 6-digit code.",
    authenticatorEnabled: "Authenticator App enabled successfully.",
    authenticatorStatusFailed: "Failed to load Authenticator App status.",
    authenticatorSetupFailed: "Failed to start Authenticator App setup.",
    authenticatorEnableFailed: "Failed to enable Authenticator App.",
    mfaTip: "Enable multi-factor authentication to secure your account",
    oldPassword: "Old Password",
    newPassword: "New Password",
    newPasswordConfirm: "Confirm New Password",
    
    // Error messages
    somethingWentWrong: "Oops! Something went wrong.",
    errorMessage: "We're sorry, but something unexpected happened. Please try refreshing the page.",
    reloadPage: "Reload Page",
    errorDetails: "Error Details (Development):",
    
    // Success messages
    ticketCreated: "Ticket created successfully!",
    walletAdded: "Wallet added successfully!",
    paymentMethodAdded: "Payment method added successfully!",
    settingsSaved: "Settings saved successfully!",
    
    // Validation messages
    required: "This field is required",
    invalidEmail: "Please enter a valid email address",
    passwordMismatch: "Passwords do not match",
    minLength: "Minimum length is {min} characters",
    maxLength: "Maximum length is {max} characters",
    
    // Wallets specific
    yourAssets: "Your Assets",
    totalAssets: "Total Assets",
    sendFunds: "Send Funds",
    receiveFunds: "Receive Funds",
    selectWallet: "Select Wallet",
    enterAddress: "Enter Address",
    available: "Available",
    max: "MAX",
    paste: "Paste",
    send: "Send",
    receiving: "Receiving",
    walletAddress: "Wallet Address",
    copyAddress: "Copy Address",
    generatingAddress: "Generating address...",
    addressCopied: "Address copied to clipboard!",
    
    // Overview specific
    currentBalance: "Current Balance",
    balanceAcrossAccounts: "Balance across all your accounts",
    availableCurrency: "AVAILABLE CURRENCY",
    bitcoin: "Bitcoin",
    ethereum: "Ethereum",
    usDollars: "US Dollars",
    kycNotVerified: "KYC Not Verified",
    kycDescription: "Your account is not verified, you can only use the basic features, please verify your account.",
    verifyNow: "Verify Now",
    seeAll: "See All",
    nothingHere: "Oops! Nothing is here.",
    noTransactions: "We couldn't find any transactions.",
    noPayments: "We couldn't find any payments.",
    
    // Payments specific
    deposit: "Deposit",
    withdraw: "Withdraw",
    amount: "Amount",
    fee: "Fee",
    total: "Total",
    confirmDeposit: "Confirm Deposit",
    depositCalculating: "Calculating deposit...",
    liveRates: "Live rates from Binance",
    balanceError: "Insufficient balance for withdrawal",
    
    // Support Tickets specific
    ticketId: "Ticket ID",
    closed: "CLOSED",
    open: "OPEN",
    addReply: "Add Reply",
    addReplyAndClose: "Add Reply & Close Ticket",
    uploadFile: "Upload File",
    replyPlaceholder: "Type your reply here...",
    noMessages: "No messages yet",
    
    // Common UI
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    previous: "Previous",
    close: "Close",
    open: "Open",
    status: "Status",
    date: "Date",
    currency: "Currency",
    description: "Description",
    actions: "Actions",
    submit: "Submit",
    creating: "Creating...",
    sending: "Sending...",
    updating: "Updating...",
    deleting: "Deleting...",
    
    // Notifications
    profileUpdated: "Profile updated successfully!",
    paymentMethodCreated: "Payment method created successfully!",
    paymentMethodDeleted: "Payment method deleted successfully!",
    transactionSent: "Transaction sent successfully!",
    settingsSaved: "Settings saved successfully!",
    
    // Errors
    sessionExpired: "Session expired. Please log in again.",
    authenticationRequired: "Authentication required. Please log in again.",
    walletNotFound: "Wallet not found. Please select a valid wallet.",
    insufficientBalance: "Insufficient balance for this transaction.",
    invalidAddress: "Invalid address format.",
    networkError: "Network error. Please try again.",
    unknownError: "An unknown error occurred. Please try again.",
  },
  
  de: {
    // Dashboard
    dashboard: "Dashboard",
    overview: "Übersicht",
    accountSettings: "Kontoeinstellungen",
    payments: "Zahlungen",
    wallets: "Geldbörsen",
    transactions: "Transaktionen",
    supportTickets: "Support-Tickets",
    safetyGuide: "Sicherheitsleitfaden",
    exchange: "Börse",
    swapCrypto: "Krypto tauschen",
    swap: "Tauschen",
    stake: "Staking",
    
    // Navigation
    general: "ALLGEMEIN",
    marketplace: "MARKTPLATZ",
    needHelp: "Brauchen Sie Hilfe?",
    contactSupport: "Support kontaktieren",
    contactSupportTeam: "Kontaktieren Sie unser Kundensupport-Team",
    
    // TopBar
    notifications: "Benachrichtigungen",
    profile: "Profil",
    logout: "Abmelden",
    
    // Support Tickets
    createTicket: "Ticket erstellen",
    createSupportTicket: "Support-Ticket erstellen",
    noActiveTickets: "Keine aktiven Support-Tickets",
    loadingTickets: "Tickets werden geladen...",
    goBack: "Zurück",
    subject: "Betreff",
    urgency: "Dringlichkeit",
    message: "Nachricht",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    createTicketButton: "Ticket erstellen",
    creating: "Erstelle...",
    ticketNote: "Bitte beachten Sie, dass Support-Tickets normalerweise innerhalb von 24 Stunden beantwortet werden, abhängig von der Dringlichkeit des Tickets.",
    supportTicketNote: "Bitte beachten Sie, dass Support-Tickets normalerweise innerhalb von 24 Stunden beantwortet werden, abhängig von der Dringlichkeit des Tickets.",
    
    // Common
    loading: "Laden...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    save: "Speichern",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirm: "Bestätigen",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    close: "Schließen",
    open: "Öffnen",
    status: "Status",
    date: "Datum",
    amount: "Betrag",
    currency: "Währung",
    description: "Beschreibung",
    actions: "Aktionen",
    
    // Overview
    totalBalance: "Gesamtsaldo",
    portfolioValue: "Portfoliowert",
    totalProfit: "Gesamtgewinn",
    totalLoss: "Gesamtverlust",
    recentTransactions: "Letzte Transaktionen",
    marketTrends: "Markttrends",
    quickActions: "Schnellaktionen",
    buyCrypto: "Krypto kaufen",
    sendMoney: "Geld senden",
    receiveMoney: "Geld empfangen",
    
    // Wallets
    myWallets: "Meine Geldbörsen",
    addWallet: "Geldbörse hinzufügen",
    walletAddress: "Geldbörsen-Adresse",
    walletBalance: "Geldbörsen-Saldo",
    walletType: "Geldbörsen-Typ",
    hotWallet: "Hot Wallet",
    coldWallet: "Cold Wallet",
    
    // Transactions
    transactionHistory: "Transaktionsverlauf",
    transactionType: "Transaktionstyp",
    transactionStatus: "Transaktionsstatus",
    from: "Von",
    to: "An",
    fee: "Gebühr",
    hash: "Hash",
    pending: "Ausstehend",
    processing: "In Bearbeitung",
    completed: "Abgeschlossen",
    failed: "Fehlgeschlagen",
    cancelled: "Abgebrochen",
    
    // Payments
    paymentMethods: "Zahlungsmethoden",
    addPaymentMethod: "Zahlungsmethode hinzufügen",
    creditCard: "Kreditkarte",
    bankAccount: "Bankkonto",
    cryptoWallet: "Krypto-Geldbörse",
    cardNumber: "Kartennummer",
    expiryDate: "Ablaufdatum",
    cvv: "CVV",
    accountNumber: "Kontonummer",
    routingNumber: "Routing-Nummer",
    
    // Exchange
    cryptoExchange: "Krypto-Börse",
    buy: "Kaufen",
    sell: "Verkaufen",
    swap: "Tauschen",
    fromCurrency: "Von Währung",
    toCurrency: "Zu Währung",
    exchangeRate: "Wechselkurs",
    estimatedAmount: "Geschätzter Betrag",
    confirmExchange: "Börse bestätigen",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Gestaketer Betrag",
    rewards: "Belohnungen",
    apy: "APY",
    lockPeriod: "Sperrzeit",
    unstake: "Unstake",
    stakeMore: "Mehr staken",
    
    // Stake Elements
    duration: "Dauer",
    rate: "Rate",
    minValue: "Min. Wert",
    maxValue: "Max. Wert",
    days7: "7 Tage",
    days14: "14 Tage",
    days30: "30 Tage",
    
    // Cryptocurrency Names for Staking
    bitcoinStake: "Bitcoin Staking",
    ethereumStake: "Ethereum Staking",
    tetherUsdtStake: "Tether USDT Staking",
    bnbStake: "BNB Staking",
    solanaStake: "Solana Staking",
    xrpStake: "XRP Staking",
    cardanoStake: "Cardano Staking",
    dogecoinStake: "Dogecoin Staking",
    litecoinStake: "Litecoin Staking",
    moneroStake: "Monero Staking",
    polygonStake: "Polygon Staking",
    tronStake: "TRON Staking",
    usdStake: "USD Staking",
    eurStake: "EUR Staking",
    
    // Account Settings
    personalInformation: "Persönliche Informationen",
    security: "Sicherheit",
    notifications: "Benachrichtigungen",
    
    // Account Settings - Basic Details
    basicDetails: "Grunddaten",
    emailAddress: "E-Mail-Adresse",
    dateOfBirth: "Geburtsdatum",
    city: "Stadt",
    postalCode: "Postleitzahl",
    fullAddress: "Vollständige Adresse",
    dateFormatHint: "Format: JJJJ-MM-TT",
    saveChanges: "Änderungen speichern",
    loadingUserData: "Benutzerdaten werden geladen...",
    
    // Account Settings - Payment Methods
    paymentMethodsDesc: "Fügen Sie Zahlungsmethoden hinzu und verwalten Sie diese für Ein- und Auszahlungen",
    addNew: "Neu hinzufügen",
    nothingHere: "Nichts hier",
    addPaymentMethodToStart: "Fügen Sie eine Zahlungsmethode hinzu, um zu beginnen",
    
    // Account Settings - Verification
    verification: "Verifizierung",
    verifyAccountKyc: "Verifizieren Sie Ihr Konto mit KYC",
    personalInformation: "Persönliche Informationen",
    personalInformationDesc: "Bitte geben Sie Ihre persönlichen Informationen an, um den Verifizierungsprozess abzuschließen",
    documentUpload: "Dokumenten-Upload",
    documentUploadDesc: "Laden Sie Ihre Identifikationsdokumente zur Verifizierung hoch",
    uploadDocuments: "Dokumente hochladen",
    verificationComplete: "Verifizierung abgeschlossen",
    completeKycVerification: "KYC-Verifizierung abschließen",
    completeKycVerificationDesc: "Ihre Verifizierung ist abgeschlossen. Sie können jetzt alle Funktionen nutzen.",
    startKycVerification: "KYC-Verifizierung starten",
    nextStep: "Nächster Schritt",
    driverLicense: "Ausweisdokument (Vorderseite)",
    selfie: "Selfie",
    driverLicenseDesc: "Laden Sie ein deutliches Foto Ihres Identitätsdokuments hoch.",
    selfieDesc: "Machen Sie ein klares Selfie mit sichtbarem Gesicht",
    alreadyUploaded: "Bereits hochgeladen",
    clickToReplace: "Klicken zum Ersetzen",
    uploadSelectedDocuments: "Ausgewählte Dokumente hochladen",
    uploadBothDocuments: "Beide Dokumente hochladen",
    documentsAlreadyUploaded: "Dokumente bereits hochgeladen",
    viewFullSize: "Vollgröße anzeigen",
    uploading: "Hochladen...",
    isVerified: "ist verifiziert",
    notVerified: "nicht verifiziert",
    kycIsVerified: "KYC ist verifiziert",
    kycNotVerified: "KYC nicht verifiziert",
    kycVerifiedDescription: "Ihr Konto ist verifiziert, Sie können alle Funktionen nutzen",
    
    // Account Settings - Notifications
    emailNotifications: "E-Mail-Benachrichtigungen",
    transactionReceived: "Transaktion empfangen",
    transactionReceivedDesc: "Erhalten Sie Benachrichtigungen, wenn Sie Geld erhalten",
    transactionSent: "Transaktion gesendet",
    transactionSentDesc: "Erhalten Sie Benachrichtigungen, wenn Sie Geld senden",
    accountChanges: "Kontoänderungen",
    accountChangesDesc: "Erhalten Sie Benachrichtigungen über wichtige Kontoänderungen",
    stakeRewards: "Staking-Belohnungen",
    stakeRewardsDesc: "Erhalten Sie Benachrichtigungen über Ihre Staking-Belohnungen",
    
    // Account Settings - Security
    loginHistory: "Anmeldeverlauf",
    recentLoginActivity: "Letzte Anmeldeaktivität",
    loginType: "Anmeldetyp",
    ipAddress: "IP-Adresse",
    client: "Client",
    multiFactorAuthentication: "Multi-Faktor-Authentifizierung",
    authenticatorApp: "Authenticator-App",
    authenticatorAppDesc: "Verwenden Sie eine Authenticator-App für zusätzliche Sicherheit",
    emailAuthentication: "E-Mail-Authentifizierung",
    emailAuthenticationDesc: "Erhalten Sie Authentifizierungscodes per E-Mail",
    setUp: "Einrichten",
    mfaTip: "Aktivieren Sie die Multi-Faktor-Authentifizierung, um Ihr Konto zu sichern",
    oldPassword: "Altes Passwort",
    newPassword: "Neues Passwort",
    newPasswordConfirm: "Neues Passwort bestätigen",
    preferences: "Einstellungen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    country: "Land",
    timezone: "Zeitzone",
    language: "Sprache",
    changePassword: "Passwort ändern",
    twoFactorAuth: "Zwei-Faktor-Authentifizierung",
    enable2FA: "2FA aktivieren",
    disable2FA: "2FA deaktivieren",
    
    // Error messages
    somethingWentWrong: "Hoppla! Etwas ist schiefgelaufen.",
    errorMessage: "Es tut uns leid, aber etwas Unerwartetes ist passiert. Bitte versuchen Sie, die Seite zu aktualisieren.",
    reloadPage: "Seite neu laden",
    errorDetails: "Fehlerdetails (Entwicklung):",
    
    // Success messages
    ticketCreated: "Ticket erfolgreich erstellt!",
    walletAdded: "Geldbörse erfolgreich hinzugefügt!",
    paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt!",
    settingsSaved: "Einstellungen erfolgreich gespeichert!",
    
    // Validation messages
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordMismatch: "Passwörter stimmen nicht überein",
    minLength: "Mindestlänge ist {min} Zeichen",
    maxLength: "Maximallänge ist {max} Zeichen",
    
    // Wallets specific
    yourAssets: "Ihre Assets",
    totalAssets: "Gesamt-Assets",
    sendFunds: "Gelder senden",
    receiveFunds: "Gelder empfangen",
    selectWallet: "Geldbörse auswählen",
    enterAddress: "Adresse eingeben",
    available: "Verfügbar",
    max: "MAX",
    paste: "Einfügen",
    send: "Senden",
    receiving: "Empfangen",
    walletAddress: "Geldbörsen-Adresse",
    copyAddress: "Adresse kopieren",
    generatingAddress: "Adresse wird generiert...",
    addressCopied: "Adresse in Zwischenablage kopiert!",
    
    // Overview specific
    currentBalance: "Aktueller Saldo",
    balanceAcrossAccounts: "Saldo über alle Ihre Konten",
    availableCurrency: "VERFÜGBARE WÄHRUNG",
    bitcoin: "Bitcoin",
    ethereum: "Ethereum",
    usDollars: "US-Dollar",
    kycNotVerified: "KYC nicht verifiziert",
    kycDescription: "Ihr Konto ist nicht verifiziert, Sie können nur die grundlegenden Funktionen nutzen. Bitte verifizieren Sie Ihr Konto.",
    verifyNow: "Jetzt verifizieren",
    seeAll: "Alle anzeigen",
    nothingHere: "Hoppla! Hier ist nichts.",
    noTransactions: "Wir konnten keine Transaktionen finden.",
    
    // Payments specific
    deposit: "Einzahlung",
    withdraw: "Auszahlung",
    fee: "Gebühr",
    total: "Gesamt",
    confirmDeposit: "Einzahlung bestätigen",
    depositCalculating: "Einzahlung wird berechnet...",
    liveRates: "Live-Kurse von Binance",
    balanceError: "Unzureichender Saldo für Auszahlung",
    
    // Support Tickets specific
    ticketId: "Ticket-ID",
    closed: "GESCHLOSSEN",
    open: "OFFEN",
    addReply: "Antwort hinzufügen",
    addReplyAndClose: "Antwort hinzufügen & Ticket schließen",
    uploadFile: "Datei hochladen",
    replyPlaceholder: "Geben Sie hier Ihre Antwort ein...",
    noMessages: "Noch keine Nachrichten",
    
    // Common UI
    submit: "Absenden",
    sending: "Senden...",
    updating: "Aktualisieren...",
    deleting: "Löschen...",
    
    // Notifications
    profileUpdated: "Profil erfolgreich aktualisiert!",
    paymentMethodCreated: "Zahlungsmethode erfolgreich erstellt!",
    paymentMethodDeleted: "Zahlungsmethode erfolgreich gelöscht!",
    transactionSent: "Transaktion erfolgreich gesendet!",
    settingsSaved: "Einstellungen erfolgreich gespeichert!",
    
    // Errors
    sessionExpired: "Sitzung abgelaufen. Bitte melden Sie sich erneut an.",
    authenticationRequired: "Authentifizierung erforderlich. Bitte melden Sie sich erneut an.",
    walletNotFound: "Geldbörse nicht gefunden. Bitte wählen Sie eine gültige Geldbörse.",
    insufficientBalance: "Unzureichender Saldo für diese Transaktion.",
    invalidAddress: "Ungültiges Adressformat.",
    networkError: "Netzwerkfehler. Bitte versuchen Sie es erneut.",
    unknownError: "Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    high: "Hoch",
    createTicketButton: "Ticket erstellen",
    creating: "Wird erstellt...",
    ticketNote: "Bitte beachten Sie, dass Support-Tickets normalerweise innerhalb von 24 Stunden beantwortet werden, je nach Dringlichkeit des Tickets.",
    
    // Common
    loading: "Wird geladen...",
    error: "Fehler",
    success: "Erfolg",
    cancel: "Abbrechen",
    save: "Speichern",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirm: "Bestätigen",
    back: "Zurück",
    next: "Weiter",
    previous: "Zurück",
    close: "Schließen",
    open: "Öffnen",
    status: "Status",
    date: "Datum",
    amount: "Betrag",
    currency: "Währung",
    description: "Beschreibung",
    actions: "Aktionen",
    
    // Overview
    totalBalance: "Gesamtsaldo",
    portfolioValue: "Portfoliowert",
    totalProfit: "Gesamtgewinn",
    totalLoss: "Gesamtverlust",
    recentTransactions: "Letzte Transaktionen",
    marketTrends: "Markttrends",
    quickActions: "Schnellaktionen",
    buyCrypto: "Krypto kaufen",
    sendMoney: "Geld senden",
    receiveMoney: "Geld empfangen",
    
    // Wallets
    myWallets: "Meine Geldbörsen",
    addWallet: "Geldbörse hinzufügen",
    walletAddress: "Geldbörsen-Adresse",
    walletBalance: "Geldbörsen-Saldo",
    walletType: "Geldbörsen-Typ",
    hotWallet: "Hot Wallet",
    coldWallet: "Cold Wallet",
    
    // Transactions
    transactionHistory: "Transaktionsverlauf",
    transactionType: "Transaktionstyp",
    transactionStatus: "Transaktionsstatus",
    from: "Von",
    to: "An",
    fee: "Gebühr",
    hash: "Hash",
    pending: "Ausstehend",
    processing: "In Bearbeitung",
    completed: "Abgeschlossen",
    failed: "Fehlgeschlagen",
    cancelled: "Abgebrochen",
    
    // Payments
    paymentMethods: "Zahlungsmethoden",
    addPaymentMethod: "Zahlungsmethode hinzufügen",
    creditCard: "Kreditkarte",
    bankAccount: "Bankkonto",
    cryptoWallet: "Krypto-Geldbörse",
    cardNumber: "Kartennummer",
    expiryDate: "Ablaufdatum",
    cvv: "CVV",
    accountNumber: "Kontonummer",
    routingNumber: "Routing-Nummer",
    
    // Exchange
    cryptoExchange: "Krypto-Börse",
    buy: "Kaufen",
    sell: "Verkaufen",
    swap: "Tauschen",
    fromCurrency: "Von Währung",
    toCurrency: "Zu Währung",
    exchangeRate: "Wechselkurs",
    estimatedAmount: "Geschätzter Betrag",
    confirmExchange: "Börse bestätigen",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Gestaketer Betrag",
    rewards: "Belohnungen",
    apy: "APY",
    lockPeriod: "Sperrzeit",
    unstake: "Unstake",
    stakeMore: "Mehr staken",
    
    // Account Settings
    personalInformation: "Persönliche Informationen",
    security: "Sicherheit",
    notifications: "Benachrichtigungen",
    preferences: "Einstellungen",
    firstName: "Vorname",
    lastName: "Nachname",
    email: "E-Mail",
    phone: "Telefon",
    country: "Land",
    timezone: "Zeitzone",
    language: "Sprache",
    changePassword: "Passwort ändern",
    twoFactorAuth: "Zwei-Faktor-Authentifizierung",
    enable2FA: "2FA aktivieren",
    disable2FA: "2FA deaktivieren",
    
    // Error messages
    somethingWentWrong: "Hoppla! Etwas ist schiefgelaufen.",
    errorMessage: "Es tut uns leid, aber etwas Unerwartetes ist passiert. Bitte versuchen Sie, die Seite zu aktualisieren.",
    reloadPage: "Seite neu laden",
    errorDetails: "Fehlerdetails (Entwicklung):",
    
    // Success messages
    ticketCreated: "Ticket erfolgreich erstellt!",
    walletAdded: "Geldbörse erfolgreich hinzugefügt!",
    paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt!",
    settingsSaved: "Einstellungen erfolgreich gespeichert!",
    
    // Validation messages
    required: "Dieses Feld ist erforderlich",
    invalidEmail: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    passwordMismatch: "Passwörter stimmen nicht überein",
    minLength: "Mindestlänge ist {min} Zeichen",
    maxLength: "Maximale Länge ist {max} Zeichen",
  },
  
  es: {
    // Dashboard
    dashboard: "Panel de Control",
    overview: "Resumen",
    accountSettings: "Configuración de Cuenta",
    payments: "Pagos",
    wallets: "Billeteras",
    transactions: "Transacciones",
    supportTickets: "Tickets de Soporte",
    safetyGuide: "Guia de seguridad",
    exchange: "Intercambio",
    swapCrypto: "Intercambiar Cripto",
    swap: "Intercambiar",
    stake: "Staking",
    
    // Navigation
    general: "General",
    marketplace: "MERCADO",
    needHelp: "¿Necesitas ayuda?",
    contactSupport: "Contactar Soporte",
    contactSupportTeam: "Contacta a nuestro equipo de soporte al cliente",
    
    // TopBar
    notifications: "Notificaciones",
    profile: "Perfil",
    logout: "Cerrar Sesión",
    
    // Support Tickets
    createTicket: "Crear Ticket",
    createSupportTicket: "Crear Ticket de Soporte",
    noActiveTickets: "No hay Tickets de Soporte Activos",
    loadingTickets: "Cargando tickets...",
    goBack: "Volver",
    subject: "Asunto",
    urgency: "Urgencia",
    message: "Mensaje",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    createTicketButton: "Crear Ticket",
    creating: "Creando...",
    ticketNote: "Tenga en cuenta que los tickets de soporte generalmente se responden dentro de las 24 horas, dependiendo de la urgencia del ticket.",
    supportTicketNote: "Tenga en cuenta que los tickets de soporte generalmente se responden dentro de las 24 horas, dependiendo de la urgencia del ticket.",
    
    // Common
    loading: "Cargando...",
    error: "Error",
    success: "Éxito",
    cancel: "Cancelar",
    save: "Guardar",
    edit: "Editar",
    delete: "Eliminar",
    confirm: "Confirmar",
    back: "Atrás",
    next: "Siguiente",
    previous: "Anterior",
    close: "Cerrar",
    open: "Abrir",
    status: "Estado",
    date: "Fecha",
    amount: "Cantidad",
    currency: "Moneda",
    description: "Descripción",
    actions: "Acciones",
    
    // Overview
    totalBalance: "Saldo Total",
    portfolioValue: "Valor del Portafolio",
    totalProfit: "Ganancia Total",
    totalLoss: "Pérdida Total",
    recentTransactions: "Transacciones Recientes",
    marketTrends: "Tendencias del Mercado",
    quickActions: "Acciones Rápidas",
    buyCrypto: "Comprar Cripto",
    sendMoney: "Enviar Dinero",
    receiveMoney: "Recibir Dinero",
    
    // Wallets
    myWallets: "Mis Billeteras",
    addWallet: "Agregar Billetera",
    walletAddress: "Dirección de Billetera",
    walletBalance: "Saldo de Billetera",
    walletType: "Tipo de Billetera",
    hotWallet: "Billetera Caliente",
    coldWallet: "Billetera Fría",
    
    // Transactions
    transactionHistory: "Historial de Transacciones",
    transactionType: "Tipo de Transacción",
    transactionStatus: "Estado de Transacción",
    from: "De",
    to: "A",
    loadingTransactions: "Cargando transacciones...",
    noTransactions: "No se encontraron transacciones",
    fee: "Comisión",
    hash: "Hash",
    pending: "Pendiente",
    processing: "Procesando",
    completed: "Completado",
    failed: "Fallido",
    cancelled: "Cancelado",
    
    // Payments
    paymentMethods: "Métodos de Pago",
    paymentMethod: "Método de Pago",
    addPaymentMethod: "Agregar Método de Pago",
    creditCard: "Tarjeta de Crédito",
    bankAccount: "Cuenta Bancaria",
    cryptoWallet: "Billetera Cripto",
    cardNumber: "Número de Tarjeta",
    expiryDate: "Fecha de Vencimiento",
    cvv: "CVV",
    accountNumber: "Número de Cuenta",
    routingNumber: "Número de Routing",
    withdrawal: "Retiro",
    deposit: "Depósito",
    totalAmount: "Cantidad Total",
    
    // Exchange
    cryptoExchange: "Intercambio de Cripto",
    buy: "Comprar",
    sell: "Vender",
    swap: "Intercambiar",
    fromCurrency: "De Moneda",
    toCurrency: "A Moneda",
    exchangeRate: "Tipo de Cambio",
    estimatedAmount: "Cantidad Estimada",
    confirmExchange: "Confirmar Intercambio",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Cantidad Stakeada",
    rewards: "Recompensas",
    apy: "APY",
    lockPeriod: "Período de Bloqueo",
    unstake: "Unstake",
    stakeMore: "Stake Más",
    
    // Stake Elements
    duration: "Duración",
    rate: "Tasa",
    minValue: "Valor Mín.",
    maxValue: "Valor Máx.",
    days7: "7 Días",
    days14: "14 Días",
    days30: "30 Días",
    
    // Cryptocurrency Names for Staking
    bitcoinStake: "Staking de Bitcoin",
    ethereumStake: "Staking de Ethereum",
    tetherUsdtStake: "Staking de Tether USDT",
    bnbStake: "Staking de BNB",
    solanaStake: "Staking de Solana",
    xrpStake: "Staking de XRP",
    cardanoStake: "Staking de Cardano",
    dogecoinStake: "Staking de Dogecoin",
    litecoinStake: "Staking de Litecoin",
    moneroStake: "Staking de Monero",
    polygonStake: "Staking de Polygon",
    tronStake: "Staking de TRON",
    usdStake: "Staking de USD",
    eurStake: "Staking de EUR",
    
    // Account Settings
    personalInformation: "Información Personal",
    security: "Seguridad",
    notifications: "Notificaciones",
    preferences: "Preferencias",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo Electrónico",
    phone: "Teléfono",
    country: "País",
    timezone: "Zona Horaria",
    language: "Idioma",
    changePassword: "Cambiar Contraseña",
    twoFactorAuth: "Autenticación de Dos Factores",
    enable2FA: "Habilitar 2FA",
    disable2FA: "Deshabilitar 2FA",
    
    // Account Settings - Basic Details
    basicDetails: "Datos Básicos",
    emailAddress: "Dirección de Correo",
    dateOfBirth: "Fecha de Nacimiento",
    city: "Ciudad",
    postalCode: "Código Postal",
    fullAddress: "Dirección Completa",
    dateFormatHint: "Formato: AAAA-MM-DD",
    saveChanges: "Guardar Cambios",
    loadingUserData: "Cargando datos del usuario...",
    
    // Account Settings - Payment Methods
    paymentMethodsDesc: "Agregue y administre sus métodos de pago para depósitos y retiros",
    addNew: "Agregar Nuevo",
    nothingHere: "Nada aquí",
    addPaymentMethodToStart: "Agregue un método de pago para comenzar",
    
    // Account Settings - Verification
    verification: "Verificación",
    verifyAccountKyc: "Verifique su cuenta con KYC",
    personalInformation: "Información Personal",
    personalInformationDesc: "Por favor proporcione su información personal para completar el proceso de verificación",
    documentUpload: "Carga de Documentos",
    documentUploadDesc: "Cargue sus documentos de identificación para verificación",
    uploadDocuments: "Cargar Documentos",
    verificationComplete: "Verificación Completada",
    completeKycVerification: "Completar Verificación KYC",
    completeKycVerificationDesc: "Su verificación está completa. Ahora puede usar todas las funciones.",
    startKycVerification: "Iniciar Verificación KYC",
    nextStep: "Siguiente Paso",
    driverLicense: "Prueba de Identidad (Anverso)",
    selfie: "Selfie",
    driverLicenseDesc: "Suba una foto clara de su documento de identificación.",
    selfieDesc: "Tome una selfie clara con su rostro visible",
    alreadyUploaded: "Ya cargado",
    clickToReplace: "Haga clic para reemplazar",
    uploadSelectedDocuments: "Cargar Documentos Seleccionados",
    uploadBothDocuments: "Cargar Ambos Documentos",
    documentsAlreadyUploaded: "Documentos Ya Cargados",
    viewFullSize: "Ver Tamaño Completo",
    uploading: "Subiendo...",
    isVerified: "está verificado",
    notVerified: "no está verificado",
    kycIsVerified: "KYC está verificado",
    kycNotVerified: "KYC no está verificado",
    kycVerifiedDescription: "Su cuenta está verificada, puede usar todas las funciones",
    
    // Account Settings - Notifications
    emailNotifications: "Notificaciones por Correo",
    transactionReceived: "Transacción Recibida",
    transactionReceivedDesc: "Reciba notificaciones cuando reciba fondos",
    transactionSent: "Transacción Enviada",
    transactionSentDesc: "Reciba notificaciones cuando envíe fondos",
    accountChanges: "Cambios de Cuenta",
    accountChangesDesc: "Reciba notificaciones sobre cambios importantes en la cuenta",
    stakeRewards: "Recompensas de Staking",
    stakeRewardsDesc: "Reciba notificaciones sobre sus recompensas de staking",
    
    // Account Settings - Security
    loginHistory: "Historial de Inicio de Sesión",
    recentLoginActivity: "Actividad reciente de inicio de sesión",
    loginType: "Tipo de Inicio de Sesión",
    ipAddress: "Dirección IP",
    client: "Cliente",
    multiFactorAuthentication: "Autenticación Multi-Factor",
    authenticatorApp: "Aplicación Autenticadora",
    authenticatorAppDesc: "Use una aplicación autenticadora para seguridad adicional",
    emailAuthentication: "Autenticación por Correo",
    emailAuthenticationDesc: "Reciba códigos de autenticación por correo electrónico",
    setUp: "Configurar",
    mfaTip: "Habilite la autenticación multi-factor para asegurar su cuenta",
    oldPassword: "Contraseña Anterior",
    newPassword: "Nueva Contraseña",
    newPasswordConfirm: "Confirmar Nueva Contraseña",
    
    // Error messages
    somethingWentWrong: "¡Ups! Algo salió mal.",
    errorMessage: "Lo sentimos, pero algo inesperado sucedió. Por favor, intente actualizar la página.",
    reloadPage: "Recargar Página",
    errorDetails: "Detalles del Error (Desarrollo):",
    
    // Success messages
    ticketCreated: "¡Ticket creado exitosamente!",
    walletAdded: "¡Billetera agregada exitosamente!",
    paymentMethodAdded: "¡Método de pago agregado exitosamente!",
    settingsSaved: "¡Configuración guardada exitosamente!",
    
    // Validation messages
    required: "Este campo es requerido",
    invalidEmail: "Por favor ingrese una dirección de correo válida",
    passwordMismatch: "Las contraseñas no coinciden",
    minLength: "La longitud mínima es {min} caracteres",
    maxLength: "La longitud máxima es {max} caracteres",
    
    // Wallets specific
    yourAssets: "Sus Activos",
    totalAssets: "Activos Totales",
    sendFunds: "Enviar Fondos",
    receiveFunds: "Recibir Fondos",
    selectWallet: "Seleccionar Billetera",
    enterAddress: "Ingresar Dirección",
    available: "Disponible",
    max: "MÁX",
    paste: "Pegar",
    send: "Enviar",
    receiving: "Recibiendo",
    walletAddress: "Dirección de Billetera",
    copyAddress: "Copiar Dirección",
    generatingAddress: "Generando dirección...",
    addressCopied: "¡Dirección copiada al portapapeles!",
    
    // Overview specific
    currentBalance: "Saldo Actual",
    balanceAcrossAccounts: "Saldo en todas sus cuentas",
    availableCurrency: "MONEDA DISPONIBLE",
    bitcoin: "Bitcoin",
    ethereum: "Ethereum",
    usDollars: "Dólares Estadounidenses",
    kycNotVerified: "KYC No Verificado",
    kycDescription: "Su cuenta no está verificada, solo puede usar las funciones básicas, por favor verifique su cuenta.",
    verifyNow: "Verificar Ahora",
    seeAll: "Ver Todo",
    nothingHere: "¡Ups! No hay nada aquí.",
    noTransactions: "No pudimos encontrar ninguna transacción.",
    noPayments: "No pudimos encontrar ningún pago.",
    
    // Payments specific
    deposit: "Depósito",
    withdraw: "Retiro",
    fee: "Comisión",
    total: "Total",
    confirmDeposit: "Confirmar Depósito",
    depositCalculating: "Calculando depósito...",
    liveRates: "Tasas en vivo de Binance",
    balanceError: "Saldo insuficiente para retiro",
    
    // Support Tickets specific
    ticketId: "ID de Ticket",
    closed: "CERRADO",
    open: "ABIERTO",
    addReply: "Agregar Respuesta",
    addReplyAndClose: "Agregar Respuesta y Cerrar Ticket",
    uploadFile: "Subir Archivo",
    replyPlaceholder: "Escriba su respuesta aquí...",
    noMessages: "Aún no hay mensajes",
    
    // Common UI
    submit: "Enviar",
    sending: "Enviando...",
    updating: "Actualizando...",
    deleting: "Eliminando...",
    
    // Notifications
    profileUpdated: "¡Perfil actualizado exitosamente!",
    paymentMethodCreated: "¡Método de pago creado exitosamente!",
    paymentMethodDeleted: "¡Método de pago eliminado exitosamente!",
    transactionSent: "¡Transacción enviada exitosamente!",
    settingsSaved: "¡Configuración guardada exitosamente!",
    
    // Errors
    sessionExpired: "Sesión expirada. Por favor inicie sesión nuevamente.",
    authenticationRequired: "Autenticación requerida. Por favor inicie sesión nuevamente.",
    walletNotFound: "Billetera no encontrada. Por favor seleccione una billetera válida.",
    insufficientBalance: "Saldo insuficiente para esta transacción.",
    invalidAddress: "Formato de dirección inválido.",
    networkError: "Error de red. Por favor intente nuevamente.",
    unknownError: "Ocurrió un error desconocido. Por favor intente nuevamente.",
    bankAccount: "Cuenta Bancaria",
    cryptoWallet: "Billetera Cripto",
    cardNumber: "Número de Tarjeta",
    expiryDate: "Fecha de Vencimiento",
    cvv: "CVV",
    accountNumber: "Número de Cuenta",
    routingNumber: "Número de Enrutamiento",
    
    // Exchange
    cryptoExchange: "Intercambio de Cripto",
    buy: "Comprar",
    sell: "Vender",
    swap: "Intercambiar",
    fromCurrency: "De Moneda",
    toCurrency: "A Moneda",
    exchangeRate: "Tipo de Cambio",
    estimatedAmount: "Cantidad Estimada",
    confirmExchange: "Confirmar Intercambio",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Cantidad Stakeada",
    rewards: "Recompensas",
    apy: "APY",
    lockPeriod: "Período de Bloqueo",
    unstake: "Unstake",
    stakeMore: "Stake Más",
    
    // Account Settings
    personalInformation: "Información Personal",
    security: "Seguridad",
    notifications: "Notificaciones",
    preferences: "Preferencias",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo Electrónico",
    phone: "Teléfono",
    country: "País",
    timezone: "Zona Horaria",
    language: "Idioma",
    changePassword: "Cambiar Contraseña",
    twoFactorAuth: "Autenticación de Dos Factores",
    enable2FA: "Habilitar 2FA",
    disable2FA: "Deshabilitar 2FA",
    
    // Error messages
    somethingWentWrong: "¡Ups! Algo salió mal.",
    errorMessage: "Lo sentimos, pero algo inesperado sucedió. Por favor, intente actualizar la página.",
    reloadPage: "Recargar Página",
    errorDetails: "Detalles del Error (Desarrollo):",
    
    // Success messages
    ticketCreated: "¡Ticket creado exitosamente!",
    walletAdded: "¡Billetera agregada exitosamente!",
    paymentMethodAdded: "¡Método de pago agregado exitosamente!",
    settingsSaved: "¡Configuración guardada exitosamente!",
    
    // Validation messages
    required: "Este campo es requerido",
    invalidEmail: "Por favor ingrese una dirección de correo válida",
    passwordMismatch: "Las contraseñas no coinciden",
    minLength: "La longitud mínima es {min} caracteres",
    maxLength: "La longitud máxima es {max} caracteres",
  },
  
  fr: {
    // Dashboard
    dashboard: "Tableau de Bord",
    overview: "Aperçu",
    accountSettings: "Paramètres du Compte",
    payments: "Paiements",
    wallets: "Portefeuilles",
    transactions: "Transactions",
    supportTickets: "Tickets de Support",
    safetyGuide: "Guide de securite",
    exchange: "Échange",
    stake: "Staking",
    
    // Navigation
    general: "GÉNÉRAL",
    marketplace: "MARCHÉ",
    needHelp: "Besoin d'aide ?",
    contactSupport: "Contacter le Support",
    contactSupportTeam: "Contactez notre équipe de support client",
    
    // TopBar
    notifications: "Notifications",
    profile: "Profil",
    logout: "Déconnexion",
    
    // Support Tickets
    createTicket: "Créer un Ticket",
    createSupportTicket: "Créer un Ticket de Support",
    noActiveTickets: "Aucun Ticket de Support Actif",
    loadingTickets: "Chargement des tickets...",
    goBack: "Retour",
    subject: "Sujet",
    urgency: "Urgence",
    message: "Message",
    low: "Faible",
    medium: "Moyenne",
    high: "Élevée",
    createTicketButton: "Créer un Ticket",
    creating: "Création...",
    ticketNote: "Veuillez noter que les tickets de support sont généralement répondus dans les 24 heures, selon l'urgence du ticket.",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    save: "Enregistrer",
    edit: "Modifier",
    delete: "Supprimer",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    close: "Fermer",
    open: "Ouvrir",
    status: "Statut",
    date: "Date",
    amount: "Montant",
    currency: "Devise",
    description: "Description",
    actions: "Actions",
    
    // Overview
    totalBalance: "Solde Total",
    portfolioValue: "Valeur du Portefeuille",
    totalProfit: "Profit Total",
    totalLoss: "Perte Totale",
    recentTransactions: "Transactions Récentes",
    marketTrends: "Tendances du Marché",
    quickActions: "Actions Rapides",
    buyCrypto: "Acheter du Crypto",
    sendMoney: "Envoyer de l'Argent",
    receiveMoney: "Recevoir de l'Argent",
    
    // Wallets
    myWallets: "Mes Portefeuilles",
    addWallet: "Ajouter un Portefeuille",
    walletAddress: "Adresse du Portefeuille",
    walletBalance: "Solde du Portefeuille",
    walletType: "Type de Portefeuille",
    hotWallet: "Portefeuille Chaud",
    coldWallet: "Portefeuille Froid",
    
    // Transactions
    transactionHistory: "Historique des Transactions",
    transactionType: "Type de Transaction",
    transactionStatus: "Statut de Transaction",
    from: "De",
    to: "À",
    fee: "Frais",
    hash: "Hash",
    pending: "En Attente",
    processing: "En cours",
    completed: "Terminé",
    failed: "Échoué",
    cancelled: "Annulé",
    
    // Payments
    paymentMethods: "Méthodes de Paiement",
    addPaymentMethod: "Ajouter une Méthode de Paiement",
    creditCard: "Carte de Crédit",
    bankAccount: "Compte Bancaire",
    cryptoWallet: "Portefeuille Crypto",
    cardNumber: "Numéro de Carte",
    expiryDate: "Date d'Expiration",
    cvv: "CVV",
    accountNumber: "Numéro de Compte",
    routingNumber: "Numéro de Routage",
    
    // Exchange
    cryptoExchange: "Échange de Crypto",
    buy: "Acheter",
    sell: "Vendre",
    swap: "Échanger",
    fromCurrency: "De Devise",
    toCurrency: "À Devise",
    exchangeRate: "Taux de Change",
    estimatedAmount: "Montant Estimé",
    confirmExchange: "Confirmer l'Échange",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Montant Stake",
    rewards: "Récompenses",
    apy: "APY",
    lockPeriod: "Période de Verrouillage",
    unstake: "Unstake",
    stakeMore: "Stake Plus",
    
    // Stake Elements
    duration: "Durée",
    rate: "Taux",
    minValue: "Valeur Min.",
    maxValue: "Valeur Max.",
    days7: "7 Jours",
    days14: "14 Jours",
    days30: "30 Jours",
    
    // Cryptocurrency Names for Staking
    bitcoinStake: "Staking Bitcoin",
    ethereumStake: "Staking Ethereum",
    tetherUsdtStake: "Staking Tether USDT",
    bnbStake: "Staking BNB",
    solanaStake: "Staking Solana",
    xrpStake: "Staking XRP",
    cardanoStake: "Staking Cardano",
    dogecoinStake: "Staking Dogecoin",
    litecoinStake: "Staking Litecoin",
    moneroStake: "Staking Monero",
    polygonStake: "Staking Polygon",
    tronStake: "Staking TRON",
    usdStake: "Staking USD",
    eurStake: "Staking EUR",
    
    // Account Settings
    personalInformation: "Informations Personnelles",
    security: "Sécurité",
    notifications: "Notifications",
    preferences: "Préférences",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    email: "E-mail",
    phone: "Téléphone",
    country: "Pays",
    timezone: "Fuseau Horaire",
    language: "Langue",
    changePassword: "Changer le Mot de Passe",
    twoFactorAuth: "Authentification à Deux Facteurs",
    enable2FA: "Activer 2FA",
    disable2FA: "Désactiver 2FA",
    
    // Account Settings - Basic Details
    basicDetails: "Détails de Base",
    emailAddress: "Adresse E-mail",
    dateOfBirth: "Date de Naissance",
    city: "Ville",
    postalCode: "Code Postal",
    fullAddress: "Adresse Complète",
    dateFormatHint: "Format: AAAA-MM-JJ",
    saveChanges: "Enregistrer les Modifications",
    loadingUserData: "Chargement des données utilisateur...",
    
    // Account Settings - Payment Methods
    paymentMethodsDesc: "Ajoutez et gérez vos méthodes de paiement pour les dépôts et retraits",
    addNew: "Ajouter Nouveau",
    nothingHere: "Rien ici",
    addPaymentMethodToStart: "Ajoutez une méthode de paiement pour commencer",
    
    // Account Settings - Verification
    verification: "Vérification",
    verifyAccountKyc: "Vérifiez votre compte avec KYC",
    personalInformation: "Informations Personnelles",
    personalInformationDesc: "Veuillez fournir vos informations personnelles pour compléter le processus de vérification",
    documentUpload: "Téléchargement de Documents",
    documentUploadDesc: "Téléchargez vos documents d'identification pour vérification",
    uploadDocuments: "Télécharger les Documents",
    verificationComplete: "Vérification Terminée",
    completeKycVerification: "Terminer la Vérification KYC",
    completeKycVerificationDesc: "Votre vérification est terminée. Vous pouvez maintenant utiliser toutes les fonctionnalités.",
    startKycVerification: "Commencer la Vérification KYC",
    nextStep: "Étape Suivante",
    driverLicense: "Justificatif d'identité (Recto)",
    selfie: "Selfie",
    driverLicenseDesc: "Téléchargez une photo claire de votre document d'identité.",
    selfieDesc: "Prenez un selfie clair avec votre visage visible",
    alreadyUploaded: "Déjà téléchargé",
    clickToReplace: "Cliquez pour remplacer",
    uploadSelectedDocuments: "Télécharger les Documents Sélectionnés",
    uploadBothDocuments: "Télécharger les Deux Documents",
    documentsAlreadyUploaded: "Documents Déjà Téléchargés",
    viewFullSize: "Voir Taille Complète",
    uploading: "Téléchargement...",
    isVerified: "est vérifié",
    notVerified: "n'est pas vérifié",
    kycIsVerified: "KYC est vérifié",
    kycNotVerified: "KYC n'est pas vérifié",
    kycVerifiedDescription: "Votre compte est vérifié, vous pouvez utiliser toutes les fonctionnalités",
    
    // Account Settings - Notifications
    emailNotifications: "Notifications par E-mail",
    transactionReceived: "Transaction Reçue",
    transactionReceivedDesc: "Recevez des notifications lorsque vous recevez des fonds",
    transactionSent: "Transaction Envoyée",
    transactionSentDesc: "Recevez des notifications lorsque vous envoyez des fonds",
    accountChanges: "Changements de Compte",
    accountChangesDesc: "Recevez des notifications sur les changements importants du compte",
    stakeRewards: "Récompenses de Staking",
    stakeRewardsDesc: "Recevez des notifications sur vos récompenses de staking",
    
    // Account Settings - Security
    loginHistory: "Historique de Connexion",
    recentLoginActivity: "Activité récente de connexion",
    loginType: "Type de Connexion",
    ipAddress: "Adresse IP",
    client: "Client",
    multiFactorAuthentication: "Authentification Multi-Facteurs",
    authenticatorApp: "Application Authentificatrice",
    authenticatorAppDesc: "Utilisez une application authentificatrice pour une sécurité supplémentaire",
    emailAuthentication: "Authentification par E-mail",
    emailAuthenticationDesc: "Recevez des codes d'authentification par e-mail",
    setUp: "Configurer",
    mfaTip: "Activez l'authentification multi-facteurs pour sécuriser votre compte",
    oldPassword: "Ancien Mot de Passe",
    newPassword: "Nouveau Mot de Passe",
    newPasswordConfirm: "Confirmer le Nouveau Mot de Passe",
    
    // Error messages
    somethingWentWrong: "Oups ! Quelque chose s'est mal passé.",
    errorMessage: "Nous sommes désolés, mais quelque chose d'inattendu s'est produit. Veuillez essayer de rafraîchir la page.",
    reloadPage: "Recharger la Page",
    errorDetails: "Détails de l'Erreur (Développement) :",
    
    // Success messages
    ticketCreated: "Ticket créé avec succès !",
    walletAdded: "Portefeuille ajouté avec succès !",
    paymentMethodAdded: "Méthode de paiement ajoutée avec succès !",
    settingsSaved: "Paramètres enregistrés avec succès !",
    
    // Validation messages
    required: "Ce champ est requis",
    invalidEmail: "Veuillez entrer une adresse e-mail valide",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    minLength: "La longueur minimale est de {min} caractères",
    maxLength: "La longueur maximale est de {max} caractères",
    
    // Wallets specific
    yourAssets: "Vos Actifs",
    totalAssets: "Actifs Totaux",
    sendFunds: "Envoyer des Fonds",
    receiveFunds: "Recevoir des Fonds",
    selectWallet: "Sélectionner un Portefeuille",
    enterAddress: "Entrer l'Adresse",
    available: "Disponible",
    max: "MAX",
    paste: "Coller",
    send: "Envoyer",
    receiving: "Réception",
    walletAddress: "Adresse du Portefeuille",
    copyAddress: "Copier l'Adresse",
    generatingAddress: "Génération de l'adresse...",
    addressCopied: "Adresse copiée dans le presse-papiers !",
    
    // Overview specific
    currentBalance: "Solde Actuel",
    balanceAcrossAccounts: "Solde sur tous vos comptes",
    availableCurrency: "DEVISE DISPONIBLE",
    bitcoin: "Bitcoin",
    ethereum: "Ethereum",
    usDollars: "Dollars Américains",
    kycNotVerified: "KYC Non Vérifié",
    kycDescription: "Votre compte n'est pas vérifié, vous ne pouvez utiliser que les fonctionnalités de base, veuillez vérifier votre compte.",
    verifyNow: "Vérifier Maintenant",
    seeAll: "Voir Tout",
    nothingHere: "Oups ! Rien ici.",
    noTransactions: "Nous n'avons trouvé aucune transaction.",
    noPayments: "Nous n'avons trouvé aucun paiement.",
    
    // Payments specific
    deposit: "Dépôt",
    withdraw: "Retrait",
    fee: "Frais",
    total: "Total",
    confirmDeposit: "Confirmer le Dépôt",
    depositCalculating: "Calcul du dépôt...",
    liveRates: "Taux en direct de Binance",
    balanceError: "Solde insuffisant pour le retrait",
    
    // Support Tickets specific
    ticketId: "ID du Ticket",
    closed: "FERMÉ",
    open: "OUVERT",
    addReply: "Ajouter une Réponse",
    addReplyAndClose: "Ajouter une Réponse et Fermer le Ticket",
    uploadFile: "Télécharger un Fichier",
    replyPlaceholder: "Tapez votre réponse ici...",
    noMessages: "Aucun message pour le moment",
    
    // Common UI
    submit: "Soumettre",
    sending: "Envoi...",
    updating: "Mise à jour...",
    deleting: "Suppression...",
    
    // Notifications
    profileUpdated: "Profil mis à jour avec succès !",
    paymentMethodCreated: "Méthode de paiement créée avec succès !",
    paymentMethodDeleted: "Méthode de paiement supprimée avec succès !",
    transactionSent: "Transaction envoyée avec succès !",
    settingsSaved: "Paramètres enregistrés avec succès !",
    
    // Errors
    sessionExpired: "Session expirée. Veuillez vous reconnecter.",
    authenticationRequired: "Authentification requise. Veuillez vous reconnecter.",
    walletNotFound: "Portefeuille non trouvé. Veuillez sélectionner un portefeuille valide.",
    insufficientBalance: "Solde insuffisant pour cette transaction.",
    invalidAddress: "Format d'adresse invalide.",
    networkError: "Erreur réseau. Veuillez réessayer.",
    unknownError: "Une erreur inconnue s'est produite. Veuillez réessayer.",
    // Dashboard
    dashboard: "Tableau de Bord",
    overview: "Aperçu",
    accountSettings: "Paramètres du Compte",
    payments: "Paiements",
    wallets: "Portefeuilles",
    transactions: "Transactions",
    supportTickets: "Tickets de Support",
    exchange: "Échange",
    stake: "Staking",
    
    // Navigation
    general: "GÉNÉRAL",
    marketplace: "MARCHÉ",
    needHelp: "Besoin d'aide ?",
    contactSupport: "Contacter le Support",
    contactSupportTeam: "Contactez notre équipe de support client",
    
    // TopBar
    notifications: "Notifications",
    profile: "Profil",
    logout: "Déconnexion",
    
    // Support Tickets
    createTicket: "Créer un Ticket",
    createSupportTicket: "Créer un Ticket de Support",
    noActiveTickets: "Aucun Ticket de Support Actif",
    loadingTickets: "Chargement des tickets...",
    goBack: "Retour",
    subject: "Sujet",
    urgency: "Urgence",
    message: "Message",
    low: "Faible",
    medium: "Moyenne",
    high: "Élevée",
    createTicketButton: "Créer un Ticket",
    creating: "Création...",
    ticketNote: "Veuillez noter que les tickets de support sont généralement répondus dans les 24 heures, selon l'urgence du ticket.",
    
    // Common
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    cancel: "Annuler",
    save: "Enregistrer",
    edit: "Modifier",
    delete: "Supprimer",
    confirm: "Confirmer",
    back: "Retour",
    next: "Suivant",
    previous: "Précédent",
    close: "Fermer",
    open: "Ouvrir",
    status: "Statut",
    date: "Date",
    amount: "Montant",
    currency: "Devise",
    description: "Description",
    actions: "Actions",
    
    // Overview
    totalBalance: "Solde Total",
    portfolioValue: "Valeur du Portefeuille",
    totalProfit: "Profit Total",
    totalLoss: "Perte Totale",
    recentTransactions: "Transactions Récentes",
    marketTrends: "Tendances du Marché",
    quickActions: "Actions Rapides",
    buyCrypto: "Acheter du Crypto",
    sendMoney: "Envoyer de l'Argent",
    receiveMoney: "Recevoir de l'Argent",
    
    // Wallets
    myWallets: "Mes Portefeuilles",
    addWallet: "Ajouter un Portefeuille",
    walletAddress: "Adresse du Portefeuille",
    walletBalance: "Solde du Portefeuille",
    walletType: "Type de Portefeuille",
    hotWallet: "Portefeuille Chaud",
    coldWallet: "Portefeuille Froid",
    
    // Transactions
    transactionHistory: "Historique des Transactions",
    transactionType: "Type de Transaction",
    transactionStatus: "Statut de Transaction",
    from: "De",
    to: "À",
    fee: "Frais",
    hash: "Hash",
    pending: "En Attente",
    processing: "En cours",
    completed: "Terminé",
    failed: "Échoué",
    cancelled: "Annulé",
    
    // Payments
    paymentMethods: "Méthodes de Paiement",
    addPaymentMethod: "Ajouter une Méthode de Paiement",
    creditCard: "Carte de Crédit",
    bankAccount: "Compte Bancaire",
    cryptoWallet: "Portefeuille Crypto",
    cardNumber: "Numéro de Carte",
    expiryDate: "Date d'Expiration",
    cvv: "CVV",
    accountNumber: "Numéro de Compte",
    routingNumber: "Numéro de Routage",
    
    // Exchange
    cryptoExchange: "Échange de Crypto",
    buy: "Acheter",
    sell: "Vendre",
    swap: "Échanger",
    fromCurrency: "De Devise",
    toCurrency: "À Devise",
    exchangeRate: "Taux de Change",
    estimatedAmount: "Montant Estimé",
    confirmExchange: "Confirmer l'Échange",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Montant Stake",
    rewards: "Récompenses",
    apy: "APY",
    lockPeriod: "Période de Verrouillage",
    unstake: "Unstake",
    stakeMore: "Stake Plus",
    
    // Account Settings
    personalInformation: "Informations Personnelles",
    security: "Sécurité",
    notifications: "Notifications",
    preferences: "Préférences",
    firstName: "Prénom",
    lastName: "Nom de Famille",
    email: "E-mail",
    phone: "Téléphone",
    country: "Pays",
    timezone: "Fuseau Horaire",
    language: "Langue",
    changePassword: "Changer le Mot de Passe",
    twoFactorAuth: "Authentification à Deux Facteurs",
    enable2FA: "Activer 2FA",
    disable2FA: "Désactiver 2FA",
    
    // Error messages
    somethingWentWrong: "Oups ! Quelque chose s'est mal passé.",
    errorMessage: "Nous sommes désolés, mais quelque chose d'inattendu s'est produit. Veuillez essayer de rafraîchir la page.",
    reloadPage: "Recharger la Page",
    errorDetails: "Détails de l'Erreur (Développement):",
    
    // Success messages
    ticketCreated: "Ticket créé avec succès !",
    walletAdded: "Portefeuille ajouté avec succès !",
    paymentMethodAdded: "Méthode de paiement ajoutée avec succès !",
    settingsSaved: "Paramètres enregistrés avec succès !",
    
    // Validation messages
    required: "Ce champ est requis",
    invalidEmail: "Veuillez entrer une adresse e-mail valide",
    passwordMismatch: "Les mots de passe ne correspondent pas",
    minLength: "La longueur minimale est de {min} caractères",
    maxLength: "La longueur maximale est de {max} caractères",
  },
  
  pt: {
    // Dashboard
    dashboard: "Painel de Controle",
    overview: "Visão Geral",
    accountSettings: "Configurações da Conta",
    payments: "Pagamentos",
    wallets: "Carteiras",
    transactions: "Transações",
    supportTickets: "Tickets de Suporte",
    safetyGuide: "Guia de seguranca",
    exchange: "Câmbio",
    stake: "Staking",
    
    // Navigation
    general: "GERAL",
    marketplace: "MERCADO",
    needHelp: "Precisa de ajuda?",
    contactSupport: "Contatar Suporte",
    contactSupportTeam: "Entre em contato com nossa equipe de suporte ao cliente",
    
    // TopBar
    notifications: "Notificações",
    profile: "Perfil",
    logout: "Sair",
    
    // Support Tickets
    createTicket: "Criar Ticket",
    createSupportTicket: "Criar Ticket de Suporte",
    noActiveTickets: "Nenhum Ticket de Suporte Ativo",
    loadingTickets: "Carregando tickets...",
    goBack: "Voltar",
    subject: "Assunto",
    urgency: "Urgência",
    message: "Mensagem",
    low: "Baixa",
    medium: "Média",
    high: "Alta",
    createTicketButton: "Criar Ticket",
    creating: "Criando...",
    ticketNote: "Observe que os tickets de suporte geralmente são respondidos dentro de 24 horas, dependendo da urgência do ticket.",
    
    // Common
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    save: "Salvar",
    edit: "Editar",
    delete: "Excluir",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    close: "Fechar",
    open: "Abrir",
    status: "Status",
    date: "Data",
    amount: "Quantidade",
    currency: "Moeda",
    description: "Descrição",
    actions: "Ações",
    
    // Overview
    totalBalance: "Saldo Total",
    portfolioValue: "Valor do Portfólio",
    totalProfit: "Lucro Total",
    totalLoss: "Perda Total",
    recentTransactions: "Transações Recentes",
    marketTrends: "Tendências do Mercado",
    quickActions: "Ações Rápidas",
    buyCrypto: "Comprar Cripto",
    sendMoney: "Enviar Dinheiro",
    receiveMoney: "Receber Dinheiro",
    
    // Wallets
    myWallets: "Minhas Carteiras",
    addWallet: "Adicionar Carteira",
    walletAddress: "Endereço da Carteira",
    walletBalance: "Saldo da Carteira",
    walletType: "Tipo de Carteira",
    hotWallet: "Carteira Quente",
    coldWallet: "Carteira Fria",
    
    // Transactions
    transactionHistory: "Histórico de Transações",
    transactionType: "Tipo de Transação",
    transactionStatus: "Status da Transação",
    from: "De",
    to: "Para",
    fee: "Taxa",
    hash: "Hash",
    pending: "Pendente",
    processing: "Em processamento",
    completed: "Concluído",
    failed: "Falhou",
    cancelled: "Cancelado",
    
    // Payments
    paymentMethods: "Métodos de Pagamento",
    paymentMethod: "Método de Pagamento",
    addPaymentMethod: "Adicionar Método de Pagamento",
    creditCard: "Cartão de Crédito",
    bankAccount: "Conta Bancária",
    cryptoWallet: "Carteira Cripto",
    cardNumber: "Número do Cartão",
    expiryDate: "Data de Vencimento",
    cvv: "CVV",
    accountNumber: "Número da Conta",
    routingNumber: "Número de Roteamento",
    withdrawal: "Retirada",
    deposit: "Depósito",
    totalAmount: "Valor Total",
    
    // Exchange
    cryptoExchange: "Câmbio de Cripto",
    buy: "Comprar",
    sell: "Vender",
    swap: "Trocar",
    fromCurrency: "De Moeda",
    toCurrency: "Para Moeda",
    exchangeRate: "Taxa de Câmbio",
    estimatedAmount: "Quantidade Estimada",
    confirmExchange: "Confirmar Câmbio",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Quantidade Stakeada",
    rewards: "Recompensas",
    apy: "APY",
    lockPeriod: "Período de Bloqueio",
    unstake: "Unstake",
    stakeMore: "Stake Mais",
    
    // Stake Elements
    duration: "Duração",
    rate: "Taxa",
    minValue: "Valor Mín.",
    maxValue: "Valor Máx.",
    days7: "7 Dias",
    days14: "14 Dias",
    days30: "30 Dias",
    
    // Cryptocurrency Names for Staking
    bitcoinStake: "Staking Bitcoin",
    ethereumStake: "Staking Ethereum",
    tetherUsdtStake: "Staking Tether USDT",
    bnbStake: "Staking BNB",
    solanaStake: "Staking Solana",
    xrpStake: "Staking XRP",
    cardanoStake: "Staking Cardano",
    dogecoinStake: "Staking Dogecoin",
    litecoinStake: "Staking Litecoin",
    moneroStake: "Staking Monero",
    polygonStake: "Staking Polygon",
    tronStake: "Staking TRON",
    usdStake: "Staking USD",
    eurStake: "Staking EUR",
    
    // Account Settings
    personalInformation: "Informações Pessoais",
    security: "Segurança",
    notifications: "Notificações",
    preferences: "Preferências",
    firstName: "Nome",
    lastName: "Sobrenome",
    email: "E-mail",
    phone: "Telefone",
    country: "País",
    timezone: "Fuso Horário",
    language: "Idioma",
    changePassword: "Alterar Senha",
    twoFactorAuth: "Autenticação de Dois Fatores",
    enable2FA: "Ativar 2FA",
    disable2FA: "Desativar 2FA",
    
    // Error messages
    somethingWentWrong: "Ops! Algo deu errado.",
    errorMessage: "Sentimos muito, mas algo inesperado aconteceu. Por favor, tente atualizar a página.",
    reloadPage: "Recarregar Página",
    errorDetails: "Detalhes do Erro (Desenvolvimento):",
    
    // Success messages
    ticketCreated: "Ticket criado com sucesso!",
    walletAdded: "Carteira adicionada com sucesso!",
    paymentMethodAdded: "Método de pagamento adicionado com sucesso!",
    settingsSaved: "Configurações salvas com sucesso!",
    
    // Validation messages
    required: "Este campo é obrigatório",
    invalidEmail: "Por favor, insira um endereço de e-mail válido",
    passwordMismatch: "As senhas não coincidem",
    minLength: "O comprimento mínimo é {min} caracteres",
    maxLength: "O comprimento máximo é {max} caracteres",
    
    // Wallets specific
    yourAssets: "Seus Ativos",
    totalAssets: "Ativos Totais",
    sendFunds: "Enviar Fundos",
    receiveFunds: "Receber Fundos",
    selectWallet: "Selecionar Carteira",
    enterAddress: "Inserir Endereço",
    available: "Disponível",
    max: "MÁX",
    paste: "Colar",
    send: "Enviar",
    receiving: "Recebendo",
    walletAddress: "Endereço da Carteira",
    copyAddress: "Copiar Endereço",
    generatingAddress: "Gerando endereço...",
    addressCopied: "Endereço copiado para a área de transferência!",
    
    // Overview specific
    currentBalance: "Saldo Atual",
    balanceAcrossAccounts: "Saldo em todas as suas contas",
    availableCurrency: "MOEDA DISPONÍVEL",
    bitcoin: "Bitcoin",
    ethereum: "Ethereum",
    usDollars: "Dólares Americanos",
    kycNotVerified: "KYC Não Verificado",
    kycDescription: "Sua conta não está verificada, você só pode usar os recursos básicos, por favor verifique sua conta.",
    verifyNow: "Verificar Agora",
    seeAll: "Ver Tudo",
    nothingHere: "Ops! Nada aqui.",
    noTransactions: "Não conseguimos encontrar nenhuma transação.",
    noPayments: "Não conseguimos encontrar nenhum pagamento.",
    
    // Payments specific
    deposit: "Depósito",
    withdraw: "Saque",
    fee: "Taxa",
    total: "Total",
    confirmDeposit: "Confirmar Depósito",
    depositCalculating: "Calculando depósito...",
    liveRates: "Taxas ao vivo do Binance",
    balanceError: "Saldo insuficiente para saque",
    
    // Support Tickets specific
    ticketId: "ID do Ticket",
    closed: "FECHADO",
    open: "ABERTO",
    addReply: "Adicionar Resposta",
    addReplyAndClose: "Adicionar Resposta e Fechar Ticket",
    uploadFile: "Enviar Arquivo",
    replyPlaceholder: "Digite sua resposta aqui...",
    noMessages: "Ainda não há mensagens",
    
    // Common UI
    submit: "Enviar",
    sending: "Enviando...",
    updating: "Atualizando...",
    deleting: "Excluindo...",
    
    // Notifications
    profileUpdated: "Perfil atualizado com sucesso!",
    paymentMethodCreated: "Método de pagamento criado com sucesso!",
    paymentMethodDeleted: "Método de pagamento excluído com sucesso!",
    transactionSent: "Transação enviada com sucesso!",
    settingsSaved: "Configurações salvas com sucesso!",
    
    // Errors
    sessionExpired: "Sessão expirada. Por favor, faça login novamente.",
    authenticationRequired: "Autenticação necessária. Por favor, faça login novamente.",
    walletNotFound: "Carteira não encontrada. Por favor, selecione uma carteira válida.",
    insufficientBalance: "Saldo insuficiente para esta transação.",
    invalidAddress: "Formato de endereço inválido.",
    networkError: "Erro de rede. Por favor, tente novamente.",
    unknownError: "Ocorreu um erro desconhecido. Por favor, tente novamente.",
    // Dashboard
    dashboard: "Painel de Controle",
    overview: "Visão Geral",
    accountSettings: "Configurações da Conta",
    payments: "Pagamentos",
    wallets: "Carteiras",
    transactions: "Transações",
    supportTickets: "Tickets de Suporte",
    exchange: "Câmbio",
    stake: "Staking",
    
    // Navigation
    general: "GERAL",
    marketplace: "MERCADO",
    needHelp: "Precisa de ajuda?",
    contactSupport: "Contatar Suporte",
    contactSupportTeam: "Entre em contato com nossa equipe de suporte ao cliente",
    
    // TopBar
    notifications: "Notificações",
    profile: "Perfil",
    logout: "Sair",
    
    // Support Tickets
    createTicket: "Criar Ticket",
    createSupportTicket: "Criar Ticket de Suporte",
    noActiveTickets: "Nenhum Ticket de Suporte Ativo",
    loadingTickets: "Carregando tickets...",
    goBack: "Voltar",
    subject: "Assunto",
    urgency: "Urgência",
    message: "Mensagem",
    low: "Baixa",
    medium: "Média",
    high: "Alta",
    createTicketButton: "Criar Ticket",
    creating: "Criando...",
    ticketNote: "Observe que os tickets de suporte geralmente são respondidos dentro de 24 horas, dependendo da urgência do ticket.",
    
    // Common
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    save: "Salvar",
    edit: "Editar",
    delete: "Excluir",
    confirm: "Confirmar",
    back: "Voltar",
    next: "Próximo",
    previous: "Anterior",
    close: "Fechar",
    open: "Abrir",
    status: "Status",
    date: "Data",
    amount: "Valor",
    currency: "Moeda",
    description: "Descrição",
    actions: "Ações",
    
    // Overview
    totalBalance: "Saldo Total",
    portfolioValue: "Valor do Portfólio",
    totalProfit: "Lucro Total",
    totalLoss: "Perda Total",
    recentTransactions: "Transações Recentes",
    marketTrends: "Tendências do Mercado",
    quickActions: "Ações Rápidas",
    buyCrypto: "Comprar Cripto",
    sendMoney: "Enviar Dinheiro",
    receiveMoney: "Receber Dinheiro",
    
    // Wallets
    myWallets: "Minhas Carteiras",
    addWallet: "Adicionar Carteira",
    walletAddress: "Endereço da Carteira",
    walletBalance: "Saldo da Carteira",
    walletType: "Tipo de Carteira",
    hotWallet: "Carteira Quente",
    coldWallet: "Carteira Fria",
    
    // Transactions
    transactionHistory: "Histórico de Transações",
    transactionType: "Tipo de Transação",
    transactionStatus: "Status da Transação",
    from: "De",
    to: "Para",
    fee: "Taxa",
    hash: "Hash",
    pending: "Pendente",
    processing: "Em processamento",
    completed: "Concluído",
    failed: "Falhou",
    cancelled: "Cancelado",
    
    // Payments
    paymentMethods: "Métodos de Pagamento",
    addPaymentMethod: "Adicionar Método de Pagamento",
    creditCard: "Cartão de Crédito",
    bankAccount: "Conta Bancária",
    cryptoWallet: "Carteira Cripto",
    cardNumber: "Número do Cartão",
    expiryDate: "Data de Expiração",
    cvv: "CVV",
    accountNumber: "Número da Conta",
    routingNumber: "Número de Roteamento",
    
    // Exchange
    cryptoExchange: "Câmbio de Cripto",
    buy: "Comprar",
    sell: "Vender",
    swap: "Trocar",
    fromCurrency: "De Moeda",
    toCurrency: "Para Moeda",
    exchangeRate: "Taxa de Câmbio",
    estimatedAmount: "Valor Estimado",
    confirmExchange: "Confirmar Câmbio",
    
    // Stake
    staking: "Staking",
    stakedAmount: "Valor Stakeado",
    rewards: "Recompensas",
    apy: "APY",
    lockPeriod: "Período de Bloqueio",
    unstake: "Unstake",
    stakeMore: "Stake Mais",
    
    // Account Settings
    personalInformation: "Informações Pessoais",
    security: "Segurança",
    notifications: "Notificações",
    preferences: "Preferências",
    firstName: "Nome",
    lastName: "Sobrenome",
    email: "E-mail",
    phone: "Telefone",
    country: "País",
    timezone: "Fuso Horário",
    language: "Idioma",
    changePassword: "Alterar Senha",
    twoFactorAuth: "Autenticação de Dois Fatores",
    enable2FA: "Ativar 2FA",
    disable2FA: "Desativar 2FA",
    
    // Error messages
    somethingWentWrong: "Ops! Algo deu errado.",
    errorMessage: "Sentimos muito, mas algo inesperado aconteceu. Por favor, tente atualizar a página.",
    reloadPage: "Recarregar Página",
    errorDetails: "Detalhes do Erro (Desenvolvimento):",
    
    // Success messages
    ticketCreated: "Ticket criado com sucesso!",
    walletAdded: "Carteira adicionada com sucesso!",
    paymentMethodAdded: "Método de pagamento adicionado com sucesso!",
    settingsSaved: "Configurações salvas com sucesso!",
    
    // Validation messages
    required: "Este campo é obrigatório",
    invalidEmail: "Por favor, insira um endereço de e-mail válido",
    passwordMismatch: "As senhas não coincidem",
    minLength: "O comprimento mínimo é {min} caracteres",
    maxLength: "O comprimento máximo é {max} caracteres",
    
    // Account Settings - Verification
    verification: "Verificação",
    verifyAccountKyc: "Verifique sua conta com KYC",
    personalInformation: "Informações Pessoais",
    personalInformationDesc: "Por favor, forneça suas informações pessoais para completar o processo de verificação",
    documentUpload: "Upload de Documentos",
    documentUploadDesc: "Faça upload dos seus documentos de identificação para verificação",
    uploadDocuments: "Fazer Upload de Documentos",
    verificationComplete: "Verificação Concluída",
    completeKycVerification: "Completar Verificação KYC",
    completeKycVerificationDesc: "Sua verificação está completa. Agora você pode usar todos os recursos.",
    startKycVerification: "Iniciar Verificação KYC",
    nextStep: "Próximo Passo",
    driverLicense: "Comprovativo de Identidade (Frente)",
    selfie: "Selfie",
    driverLicenseDesc: "Faça upload de uma foto clara do seu Documento de Identificação.",
    selfieDesc: "Tire uma selfie clara com seu rosto visível",
    alreadyUploaded: "Já carregado",
    clickToReplace: "Clique para substituir",
    uploadSelectedDocuments: "Fazer Upload dos Documentos Selecionados",
    uploadBothDocuments: "Fazer Upload de Ambos os Documentos",
    documentsAlreadyUploaded: "Documentos Já Carregados",
    viewFullSize: "Ver Tamanho Completo",
        uploading: "Fazendo upload...",
    isVerified: "está verificado",
    notVerified: "não está verificado",
    kycIsVerified: "KYC está verificado",
    kycNotVerified: "KYC não está verificado",
    kycVerifiedDescription: "Sua conta está verificada, você pode usar todos os recursos",
    }
  };  
